if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.submitButton = this.querySelector('[type="submit"]');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        if (this.cartNotification?.setActiveElement) this.cartNotification.setActiveElement(document.activeElement);

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.setAttribute("disabled", true);
        this.submitButton.textContent = window.variantStrings.loading;

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.cartNotification?.getSectionsToRender?.().map((section) => section.id) || [],
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              this.submitButton.textContent = window.variantStrings.unavailable;
              this.submitButton.disabled = false;
              this.submitButton.removeAttribute('aria-disabled');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.handleCartData(response.sections);
                  });
                },
                {once: true},
              );
              quickAddModal.hide(true);
            } else {
              this.handleCartData(response.sections);
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage('Unable to add this item. Please try again.');
            this.submitButton.textContent = window.variantStrings.addToCart;
            this.submitButton.disabled = false;
            this.submitButton.removeAttribute('aria-disabled');
          });
      }

      async handleCartData(sections) {
        try {
          // Read the updated cart using the documented GET endpoint.
          // Never reuse the POST /cart/add.js configuration for this request.
          const result = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
            method: 'GET',
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          });
          if (!result.ok) throw new Error(`Cart refresh failed: ${result.status}`);
          const cart = await result.json();
          if (this.cartNotification && typeof this.cartNotification.renderContents === 'function') {
            this.cartNotification.renderContents(cart.items, sections || {}, 'full-cart', false, cart.total_price);
          }

        } catch (error) {
          console.error('Cart updated, but the basket could not refresh:', error);
          this.handleErrorMessage('Your basket was updated. Please open your cart to review it.');
        } finally {
          this.submitButton.textContent = window.variantStrings.addToCart;
          this.submitButton.disabled = false;
          this.submitButton.removeAttribute('aria-disabled');
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.parentElement.querySelector(
            ".product-form__error-message-wrapper",
          );

        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}


